import { Injectable } from '@angular/core';
//import { UtilsService } from './utils.service';
//import { CatalogService } from '.';

@Injectable()
export class AppLoadService {

  constructor(
      //private httpClient: HttpClient,
      //private catalog : CatalogService,
      //private utils : UtilsService
    ) {
      
    }

   initializeApp()  {
    // console.log('init app');
    return new Promise( async (resolve, reject) =>  {
        //await this.catalog.getTree(false);
        //await this.catalog.getTree(true);
        resolve();
    });

  }

//   getSettings(): Promise<any> {
//     console.log(`getSettings:: before http.get call`);
    
//     const promise = this.httpClient.get('http://private-1ad25-initializeng.apiary-mock.com/settings')
//       .toPromise()
//       .then(settings => {
//         console.log(`Settings from API: `, settings);

//         return settings;
//       });

//     return promise;
//   }
}